
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Saint-Étienne dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Saint-Étienne certifiée Google Partner, accompagne les entreprises stéphanoises pour développer leur visibilité en ligne et générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Saint-Étienne dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Saint-Étienne certifiée Google Partner, accompagne les entreprises stéphanoises pour développer leur visibilité en ligne et générer plus de prospects.",
        },
      ],
    };
  },
};
